module.exports = __webpack_public_path__ + "static/media/stop-finish.8e2e6b39.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/stop-finish.svg
// module id = 863
// module chunks = 0